const common = {
  actions: {
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    edit: 'Editar',
    delete: 'Excluir',
    create: 'Cadastrar',
    back: 'Voltar',
    close: 'Fechar',
    open: 'Abrir',
    search: 'Buscar',
    filter: 'Filtrar',
    clearFilters: 'Limpar filtros',
    apply: 'Aplicar',
    loading: 'Aguarde...',
    saving: 'Salvando...',
    yes: 'Sim',
    no: 'Não',
  },
  status: {
    active: 'Ativo',
    inactive: 'Inativo',
    activeFem: 'Ativa',
    inactiveFem: 'Inativa',
    activate: 'Ativar',
    deactivate: 'Inativar',
    reactivate: 'Reativar',
    visible: 'Visível',
    hidden: 'Oculta',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Próximo',
    page: 'Página',
    of: 'de',
    rowsPerPage: 'Linhas por página',
    showing: 'Mostrando {{from}}-{{to}} de {{total}}',
  },
  table: {
    noResults: 'Nenhum resultado encontrado.',
    loading: 'Carregando...',
    actions: 'Ações',
  },
  filters: {
    all: 'Todos',
  },
  coverage: {
    covered: 'Coberta',
    uncovered: 'Descoberta',
  },
} as const
export default common
